export default {"src":"/_next/static/media/Security.4bce7b34.svg","height":20,"width":25,"blurWidth":0,"blurHeight":0};